import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { Card, Heading, Pane } from "evergreen-ui";
import { InvoiceFormModule } from "../components";
import ControlHubContext from "../contexts/controlhub";

const InvoiceFormScreen = () => {
  const { currentCompanyId } = useContext(ControlHubContext);
  const { invoice_id } = useParams();
  if (!currentCompanyId) {
    return (
      <Pane paddingX={48} paddingY={16}>
        <Heading>Loading...</Heading>
      </Pane>
    );
  }
  return (
    <Pane minWidth="40rem" paddingX={48} paddingY={16}>
      <Heading size={600}>Edit Bill</Heading>
      <Card background="white" elevation={1} marginY={16} paddingY={16}>
        <Pane paddingX={32} paddingY={16}>
          <InvoiceFormModule id={invoice_id} />
        </Pane>
      </Card>
    </Pane>
  );
};

export default InvoiceFormScreen;
